function finiteNumber(value) {
  return typeof value === "number" && Number.isFinite(value)
    ? value
    : null;
}

function riskPercentFor(level) {
  if (level === "Low") return 1;
  if (level === "Moderate") return 0.5;
  if (level === "High") return 0.25;
  return 0;
}

export function analyzeLiveRisk({
  trade = {},
  liveDecision = {},
  accountSize = 0,
} = {}) {
  const entry = finiteNumber(trade.entry);
  const stop = finiteNumber(trade.stop);
  const target1 = finiteNumber(trade.targets?.target1);
  const target2 = finiteNumber(trade.targets?.target2);
  const target3 = finiteNumber(trade.targets?.target3);
  const capital = finiteNumber(accountSize);

  const riskLevel = liveDecision.risk || "Unknown";
  const riskPercent = riskPercentFor(riskLevel);

  const dataReady =
    entry !== null &&
    entry > 0 &&
    stop !== null &&
    target1 !== null &&
    target2 !== null &&
    target3 !== null &&
    capital !== null &&
    capital > 0;

  const decisionBlocked =
    liveDecision.status === "BLOCKED" ||
    liveDecision.status === "DATA BLOCKED";

  const calculationBlocked =
  !dataReady ||
  riskPercent <= 0 ||
  stop >= entry;

const blocked =
  calculationBlocked ||
  decisionBlocked;

const riskPerShare =
  !calculationBlocked ? Math.abs(entry - stop) : 0;

 const maximumAllowedLoss =
  !calculationBlocked ? capital * (riskPercent / 100) : 0;

  const riskBasedShares =
  !calculationBlocked && riskPerShare > 0
    ? Math.floor(maximumAllowedLoss / riskPerShare)
    : 0;

  // Never recommend a position larger than the supplied account capital
  // unless explicit buying-power/margin data is connected later.
  const capitalBasedShares =
  !calculationBlocked && entry > 0
    ? Math.floor(capital / entry)
    : 0;

  const recommendedShares =
  !calculationBlocked
    ? Math.max(
        0,
        Math.min(riskBasedShares, capitalBasedShares)
      )
    : 0;

  const positionValue = recommendedShares * (entry || 0);
  const actualMaximumLoss = recommendedShares * riskPerShare;

  const target1Shares = Math.floor(recommendedShares * 0.3);
  const target2Shares = Math.floor(recommendedShares * 0.3);
  const target3Shares =
    recommendedShares - target1Shares - target2Shares;

  const target1Profit =
    target1Shares * ((target1 || 0) - (entry || 0));

  const target2Profit =
    target2Shares * ((target2 || 0) - (entry || 0));

  const target3Profit =
    target3Shares * ((target3 || 0) - (entry || 0));

  const totalProjectedProfit =
    target1Profit + target2Profit + target3Profit;

  return {
    blocked,
    riskLevel,
    riskPercent,
    entry,
    stop,
    target1,
    target2,
    target3,
    riskPerShare,
    maximumAllowedLoss,
    actualMaximumLoss,
    recommendedShares,
    positionValue,
    buyingPowerUsed:
      capital && capital > 0
        ? (positionValue / capital) * 100
        : 0,
    target1Shares,
    target2Shares,
    target3Shares,
    target1Profit,
    target2Profit,
    target3Profit,
    totalProjectedProfit,
    sharesRemainingAfterTarget1:
      recommendedShares - target1Shares,
    sharesRemainingAfterTarget2:
      recommendedShares - target1Shares - target2Shares,
  };
}